import { useState } from 'react';
import { Button } from '@shopify/polaris';
import { StyledUrlField } from './styled';

interface IUrlFieldProps {
  url: string;
}

const UrlField = ({ url }: IUrlFieldProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1500);
    } catch {
      // graceful fail — clipboard API can throw in non-secure contexts
    }
  };

  return (
    <StyledUrlField>
      <input readOnly value={url} aria-label="MCP URL" />
      <Button onClick={handleCopy}>{isCopied ? 'Copied' : 'Copy'}</Button>
    </StyledUrlField>
  );
};

export default UrlField;
